import { ItemTilesCarousel } from '../src/ItemTilesCarousel/ItemTilesCarousel.tsx';
export default ItemTilesCarousel;
